import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-12 sm:py-16 lg:py-20 bg-amber-100">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        {/* Footer Copy */}
        <div className="text-center space-y-2">
          <p className="text-amber-800 text-sm sm:text-base">
            2026 © RanchFire Radio a division of RanchFire Multimedia, LLC
          </p>
          <p className="text-amber-900 text-base sm:text-lg font-bold">
            Rooted. Real. Country.
          </p>
        </div>
      </div>
    </footer>
  );
}
